import React, {useMemo} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {FirebaseMessageRoomItemPayload, parseShape} from 'types'
import {getFontFamily, getFontSize, parseDate} from 'utils'
import {Image, Paragraph, ParsedText} from 'common/components'
import convertUnit from 'lib/unit'

const StyledParagraph = styled(Paragraph)`
  white-space: pre-wrap;
`
const StyledContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  margin-left: ${convertUnit(10)};
`
const StyledSeparator = styled.div`
  ${({theme}) => ({backgroundColor: theme.gray_1})}
  height: ${convertUnit(1)};
  display: flex;
  width: 100%;
  margin: ${convertUnit(5)} 0;
`
const StyledItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin: ${convertUnit(5)} 0;
`

const StyledImage = styled(Image)`
  height: ${convertUnit(75)};
  aspect-ratio: 1;
  border-radius: ${convertUnit(4)};
`
interface GiftShopMessageRoomContentItemNotificationDeleteRequestProps {
  payload: FirebaseMessageRoomItemPayload['notification_report_delete_content']
}

export default function GiftShopMessageRoomContentItemNotificationDeleteRequest({
  payload: {content_image_url, content_original_at, content_title, username},
}: GiftShopMessageRoomContentItemNotificationDeleteRequestProps) {
  const {translate} = useTranslation()

  const handleRenderContent = useMemo(
    () => (
      <StyledItemContainer>
        <StyledImage src={content_image_url} alt={content_title} />
        <StyledContentInfo>
          <Paragraph fontSize="m" fontWeight="bold">
            {content_title}
          </Paragraph>
          <StyledSeparator />
          <Paragraph fontSize="m">
            {parseDate(content_original_at, 'DD MMMM YYYY')}
          </Paragraph>
        </StyledContentInfo>
      </StyledItemContainer>
    ),
    [content_image_url, content_original_at, content_title],
  )

  const parseText = useMemo<parseShape[]>(
    () => [
      {
        pattern: /<b>.*?<\/b>/,
        style: {
          fontFamily: getFontFamily('bold'),
          fontSize: getFontSize('m'),
        },
        renderText: (text) => text.replace(/<b>|<\/b>/g, ''),
      },
    ],
    [],
  )

  return (
    <>
      <StyledParagraph fontSize="m">
        <ParsedText parse={parseText}>
          {translate('messages:notificationDeleteRequest', {username})}
        </ParsedText>
      </StyledParagraph>
      {handleRenderContent}
      <StyledParagraph fontSize="m">
        <ParsedText parse={parseText}>
          {translate('messages:notificationDeleteRequestFooter')}
        </ParsedText>
      </StyledParagraph>
    </>
  )
}
